import React from "react";
import "./DataIngestion.css";
import Header from "../../Component/header/Header";
import Sidebar from "../../Component/sidebar/sidebar";
import SubDataIngestion from "../../Component/sub-dataIngestion/Sub-data-Ingestion";

function DataIngestion () {
    return(
        <div className="container">
            <div className="row row-cols-2">
                {/* sidebar */}
                <div className="col-2 sidebar">
                    <Sidebar />
                </div>

                {/* container */}
                <div className="col-10 content">
                    {/* header section */}
                    <Header title = {"Data Injestion"} />
                    <SubDataIngestion />
                </div>
            </div>
        </div>
    )
};

export default DataIngestion;